// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"VenuesSearchBar_inputWrapper__2YC9f","searchBar":"VenuesSearchBar_searchBar__1Qr3R","clearButton":"VenuesSearchBar_clearButton__x2sUf"};